<template>
  <content-dialog
    v-model="dialogOpen"
    :title="title"
    full-height
    fullscreen-tablet
    persistent
    flex
    @hide="onDialogHide"
    @show="onDialogShow"
  >
    <slot />
    <iframe
      v-if="htmlContent"
      ref="iframe"
      :srcdoc="htmlContent"
      :class="strToObj(iframeClasses, {'full-width no-border flex-100 full-height': true})"
      sandbox="allow-same-origin allow-scripts"
      @load="prepareContentBindings"
    />
  </content-dialog>
</template>

<script>
import { strToObj } from 'src/helpers/globals'

/**
 * HtmlDialog allows you to view generic HTML code inside an iFrame
 * Recommended to only render PagedJS documents here
 *
 * SLOTS:
 * - default: content to append at the top
 */
export default {
  props: {
    // Dialog title
    title: {
      type: String,
      default: 'Document Preview'
    },
    iframeClasses: {
      type: [String, Object],
      default: 'q-pa-sm'
    }
  },
  emits: ['show', 'hide'],
  data () {
    return {
      dialogOpen: false,
      htmlContent: null,
      bindDefaultFont: false
    }
  },
  methods: {
    strToObj,
    // Open the dialog with the supplied HTML
    open (content = null, props = {}) {
      this.bindDefaultFont = props.useDefaultFont === true
      this.dialogOpen = true
      this.htmlContent = content
    },
    updateContent (content) {
      if (!this.dialogOpen) {
        return
      }
      this.htmlContent = content
    },
    prepareContentBindings () {
      const iframe = this.$refs.iframe
      if (!iframe) {
        return
      }

      const content = iframe.contentDocument || iframe.contentWindow
      if (!content || !content.body) {
        return
      }

      // If true, attempt to add a default set of fonts to the iFrame to avoid basic HTML doc from using Times New Roman font
      if (this.bindDefaultFont && content.body.style && !content.body.style.fontFamily) {
        content.body.style.fontFamily = 'Roboto, -apple-system, Helvetica Neue, Helvetica, Arial, sans-serif'
      }

      // Disable all links from being clicked inside the iframe
      const links = content.getElementsByTagName('a')
      for (let i = 0; i < links.length; i++) {
        links[i].addEventListener('click', function (event) {
          event.preventDefault()
        })
      }
    },
    onDialogShow () {
      this.$emit('show')
      this.prepareContentBindings()
    },
    onDialogHide () {
      this.htmlContent = null
      this.$emit('hide')
    }
  }
}
</script>
